<template>
  <div v-if="offices" class="office-list relative">
    <!-- <div
      v-if="!!highlighted.length"
      class="offer-bar md:hidden fixed z-20 bottom-20"
      :class="{ hidden: showMap }"
    >
      <div
        class="flex-col xl:flex-row flex text-center xl:text-left gap-2 justify-between px-3 py-3 items-center"
      >
        <div class="text-sm">
          Érdeklődök a(z) {{ highlighted.length }} megjelölt irodáról
        </div>
        <div class="flex gap-3">
          <Button class="white p-2" @click="deselectAll">Mégse</Button>
          <Button class="black p-2" @click="$emit('askOffer')">OK</Button>
        </div>
      </div>
    </div> -->
    <div v-for="office in offices" :key="office.id">
      <div
        class="office-card flex items-stretch"
        @mouseenter="$emit('highlight', office)"
        @mouseleave="$emit('highlight', null)"
      >
        <!-- <div class="input-holder absolute right-3 top-3 cursor-pointer">
        <label
          :class="{ active: !!highlighted.find((id) => id === office.id) }"
        >
          <span class="inp cursor-pointer"></span>
          <input
            type="checkbox"
            :name="office.id"
            @change="() => changeValue(office.id)"
          />
        </label>
      </div> -->
        <router-link
          :to="{
            path: '/irodak/' + getSlug(office),
            hash: 'enter'
          }"
          style="aspect-ratio: 1/1"
          class="no-underline w-1/2 lg:w-1/3 aspect-square"
        >
          <img
            class="w-full h-full object-cover "
            :src="getImageUrl(office.mainImage)"
            :alt="getImageAlt(office.mainImage)"
          />
        </router-link>
        <div class="w-1/2 lg:w-2/3 flex flex-col justify-between">
          <router-link
            class="office-card__info flex flex-col no-underline"
            style="min-height: 55%"
            :to="{
              path: '/irodak/' + getSlug(office),
              hash: 'enter'
            }"
          >
            <div>
              <h3 class="p-0 m-0">{{ office.name }}</h3>
              <div class="office-card__info__address mt-1 mb-1 leading-4">
                {{ office.postalCode }} {{ office.city }},
                <br class="hidden" />{{ office.addressLine }}
              </div>
            </div>
            <div class="h-full flex flex-col mt-2 md:gap-1">
              <div
                v-if="priceTag(office)"
                class="office-card__info__icon flex gap-1 h-full items-center info"
              >
                <img class="align-middle w-5" src="@/assets/euro-1.svg" />
                <!-- <div><Price /></div> -->
                <div>{{ priceTag(office) }}</div>
                <div class="-mt--1">EUR/hó/m<sup>2</sup></div>
              </div>
              <div v-if="office.class" class="office-card__info__icon">
                <img class="align-top w-5" src="@/assets/class-1.svg" />
                {{ office.class }}
              </div>
            </div>
          </router-link>
          <router-link
            class="office-card__offie-rating mt-auto no-underline"
            style="margin-top: -10px"
            :to="{
              path: '/irodak/' + getSlug(office),
              hash: 'enter'
            }"
          >
            <span>
              <img src="@/assets/offierating.png" class="rating" />
              {{ office.offieRating || "-" }}
            </span>
          </router-link>
          <div class="office-card__buttons flex">
            <Button
              class="w-1/2 black office-card__button--details"
              :to="{ path: '/irodak/' + getSlug(office) }"
              >Részletek</Button
            >
            <Button
              class="w-1/2 blue office-card__button--offer lg:p-0"
              @click="changeValue(office)"
            >
              {{
                !!highlighted.find(o => o.id === office.id)
                  ? "Mégse -"
                  : "Kosárba +"
              }}</Button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/inputs/Button.vue";
// import Price from "@/components/icons/Price.vue";
import { mapState } from "vuex";
import slugify from "slugify";

export default {
  name: "OfficeList",
  components: { Button },
  props: ["offices"],
  data() {
    return { showMap: false };
  },
  computed: {
    ...mapState({
      highlighted: state => state.offices.highlighted
    })
  },
  methods: {
    getSlug(office) {
      return `${slugify(office.name, {
        replacement: "_",
        lower: true
      })}-${office.id}`;
    },
    getImageUrl(image) {
      if (!image) return "";
      return `${process.env.VUE_APP_API_URL}${image.formats?.small?.url ??
        image.url}`;
    },
    getImageAlt(image) {
      if (!image) return "office image";
      return image.hash;
    },
    priceTag(office) {
      if (office.priceFrom && office.priceTo) {
        return office.priceFrom == office.priceTo
          ? office.priceFrom
          : `${office.priceFrom}-${office.priceTo}`;
      } else if (office.priceFrom) {
        return office.priceFrom;
      } else if (office.priceTo) {
        return office.priceTo;
      }

      return null;
    },
    scrollToTop() {
      this.$el.scrollTop = 0;
    },
    changeValue(office) {
      this.$store.commit("offices/toggleOffice", office);
    },
    deselectAll() {
      this.$store.commit("offices/deselectAll");
    },
    showOnMobile(showMap) {
      this.showMap = showMap;
    }
  }
};
</script>

<style lang="scss">
.office-list {
  @media (max-width: $breakpoint2) {
    display: block;
  }

  .block {
    display: block;
  }

  .offer-bar {
    background: $blue;
    border-radius: 10px;
    width: 90%;
    color: white;
    font-size: 14px;
    width: 350px;
    left: calc((100% - 350px) / 2);
    box-shadow: -4px 2px 10px 2px #83837c;
  }

  grid-area: list;
  height: calc(100% - 84px);
  overflow-y: scroll;

  @media (min-width: $breakpoint2) {
    height: 100%;
  }
}

.office-card {
  position: relative;
  min-height: 200px;
  max-height: 250px;
  background: linear-gradient(180.29deg, #f0f0f0 0.25%, #cfcfcf 99.75%);
  border-radius: 16px;
  margin-bottom: 20px;
  // margin-left: auto;
  // margin-right: auto;

  .input-holder {
    label {
      position: relative;
      display: inline-flex;
      background: $white;
      border-radius: 8px;
      // padding: 2px;
      align-items: center;
      justify-content: center;
      transition: all 0.4s ease-in-out;
      cursor: pointer;
      &:hover {
        background: #e7e7e4;
      }
      input {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
      }
      .label {
        font-size: 12px;
        line-height: 16px;
        display: inline-block;
        vertical-align: bottom;
        margin-top: 4px;
      }
      .inp {
        display: inline-flex;
        border-radius: 4px;
        border: 2px solid $blue;
        width: 16px;
        height: 16px;
        justify-content: center;
        align-items: center;
        &:before {
          content: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNS4zNzUwNEw0LjQyODQ1IDhMOSAxIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMS44Ii8+Cjwvc3ZnPg==");
          display: block;
          transition: all 0.4s ease-in-out;
          transform: scale(0);
        }
      }
      &.active {
        background: $blue;
        color: $blue;
        .inp {
          background: $blue;
          border-color: $blue;
          &:before {
            transform: scale(1);
          }
        }
      }
    }
  }

  @media (max-width: $breakpoint2) {
    min-height: 200px;
    margin: 12px;
  }

  img {
    border-radius: 16px 0 0 16px;
  }

  .office-card__info {
    font-size: 14px;
    padding: 8px 16px 0 16px;
    box-sizing: border-box;

    @media (max-width: 920px) {
      padding: 6px;
    }

    .-mt--1 {
      @media (max-width: $breakpoint2) {
        margin-top: -5px;
      }
      margin-top: -3px;
    }
    .-mt--2 {
      @media (max-width: $breakpoint2) {
        margin-top: -6px;
      }
      margin-top: -11px;
    }
    .info {
      @media (max-width: 920px) {
        font-size: 0.65rem;
      }
    }

    @media (max-width: $breakpoint2) {
      padding: 12px 12px 0 12px;
    }

    h3 {
      font-weight: 700;
      color: #525252;
      line-height: normal;
      font-size: 15px;
      letter-spacing: -0.5px;

      // @media (min-width: $breakpoint2) {
      //   font-size: 14px;
      // }
      @media (min-width: $breakpoint) {
        font-size: 16px;
      }
    }

    .office-card__info__address {
      font-weight: 400;
      color: #838383;
      font-size: 12px;
      letter-spacing: -1px;

      // @media (min-width: $breakpoint2) {
      //   font-size: 10px;
      // }
      @media (min-width: $breakpoint) {
        font-size: 13px;
      }
    }

    .office-card__info__icon {
      @media (max-width: $breakpoint2) {
        margin-bottom: 3px;
        font-size: 12px;

        .align-top {
          vertical-align: -7px;
        }

        span {
          display: none;
        }

        img {
          width: 20px;
        }
      }
    }
  }

  .office-card__offie-rating {
    text-align: right;

    span {
      display: inline-block;
      background: rgba(82, 82, 82, 0.5);
      border-radius: 10px 0px 0px 10px;
      padding: 6px 16px;
      margin-bottom: 8px;

      font-weight: 700;
      font-size: 28px;
      line-height: 26px;
      color: white;

      @media (max-width: $breakpoint2) {
        margin-bottom: 8px;
      }

      img {
        height: 30px;
        vertical-align: -9px;
        margin-right: 16px;
        margin-top: 4px;
      }

      .rating {
        height: 20px;
        vertical-align: 0px;
        border-radius: 0px;
        margin-top: 0px;
      }
    }
  }

  .office-card__buttons {
    .button {
      height: 40px;
      padding: 0px;

      // @media (min-width: $breakpoint2) {
      //   font-size: 10px;
      // }
      // @media (min-width: $breakpoint) {
      //   font-size: 14px;
      // }

      @media (max-width: 920px) {
        height: 30px;

        span {
          font-size: 13px;
        }
      }
    }

    .office-card__button--details {
      border-radius: 0;
    }

    .office-card__button--offer {
      border-radius: 0 0 16px 0;
    }
  }
}
</style>
